<template>
  <form class="nav_search" @submit.prevent="submitSearch">
    <b-field class="nav_search" type="is-info">
      <b-input v-model="search" placeholder="Поиск по сайту"></b-input>
    </b-field>
  </form>
</template>

<script>
export default {
  data() {
    return {
      search: ''
    }
  },
  methods: {
    submitSearch() {
      if (this.$route.query.text === this.search) {
        return
      }
      this.$router.push('/search?text=' + this.search)
    }
  }
}
</script>
